// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';

import Col from './Col';
import LabelCell from './LabelCell';
import FormRow from './FormRow';
import DescriptionCell from './DescriptionCell';
import InputField from './InputField';
import { DesktopView, MobileView, useMobileMediaQuery } from '../config/mediaQuery';

const DescriptionField = (props: {
  value?: string | number,
  label: string,
  inline?: boolean,
  name?: string,
  readOnly?: boolean,
}) => {
  const { label, inline, ...rest } = props;
  const isMobile = useMobileMediaQuery();

  return (
    <FormRow
      css={{
        flexDirection: `${inline ? 'row' : 'column'}`,
        marginBottom: `${props.readOnly || isMobile ? 0 : 15}px`,
        ...(isMobile && inline && {
          alignItems: 'center'
        })
      }}
    >
      <DesktopView>
      {inline ? (
        <LabelCell>
          <ControlLabel>{label}</ControlLabel>
        </LabelCell>
      ) : (
        <Col>
          <ControlLabel>{label}</ControlLabel>
        </Col>
      )}
      </DesktopView>
      <MobileView>
        <div className='input-label' style={{...(!inline && { width: 'auto' })}}>
          {label}
        </div>
      </MobileView>
      <DescriptionCell>
        {props.readOnly ? (
          <FormControl componentClass="textarea" {...rest} />
        ) : (
          <InputField
            {...rest}
            css={{
              margin: 0,
            }}
            type="textarea"
          />
        )}
      </DescriptionCell>
    </FormRow>
  );
};

export default DescriptionField;
